export enum Permission {
  ReadUsers = "read:users",
  WriteUsers = "write:users",
  WriteApprove = "write:approve",
  WriteZyusetu = "write:zyusetu",
  ReadOtherZyusetu = "read:other-zyusetu",
}
